import { useSelector } from 'react-redux';
import { generateAddress } from '../utils/generateAddress';

const useCurrentAddress = () => {
  const currentHouse = useSelector(
    (state) => state.housingStockStore.currentHouse
  );

  const currentFlat = useSelector(
    (state) => state.housingStockStore.currentFlat
  );

  const address = generateAddress(currentHouse, currentFlat?.address);

  return address;
};

export default useCurrentAddress;
